/**
 * rule - show (show always), string - custom string, undefined - use id as rule
 */
export const sections = [
  // other
  {
    type: 'card',
    id: 'test',
    rule: 'show',
    name: 'Test',
    path: '/test',
  },
  {
    type: 'card',
    id: 'empty',
    rule: 'show',
    name: 'Нет прав',
    path: '/empty',
  },
  // mnemo
  {
    type: 'section',
    id: 'scheme',
    rule: 'users_mnemo.info',
    name: 'Мнемосхема',
    path: '/scheme',
    withToken: true,
  },
  // stays
  {
    type: 'section',
    id: 'stays',
    name: 'Парковки',
    path: '/stays',
    subRoutes: [{ id: 'stays', path: '/stays', exact: true }],
  },
  { type: 'card', id: 'stay', rule: 'stays.view', path: '/card/stay' },
  // clients
  {
    type: 'section',
    id: 'clients',
    name: 'Клиенты',
    path: '/clients',
    subRoutes: [{ id: 'clients', path: '/clients', exact: true }],
  },
  { type: 'card', id: 'add_client', rule: 'clients.add', path: '/card/add_client' },
  { type: 'card', id: 'client', rule: 'clients.view', path: '/card/client' },
  // payments
  {
    type: 'section',
    id: 'payments',
    rule: 'subsections',
    name: 'Средства оплаты',
    path: '/payments',
    subsections: [
      { id: 'rfid', name: 'RFID', path: '/payments/rfid' },
      { id: 'epm', name: 'БСК', path: '/payments/epm', rule: 'csc.list' },
      { id: 'plate', name: 'ГРЗ', path: '/payments/plate', rule: 'plates.list' },
      { id: 'subscription', name: 'Абонемент', path: '/payments/subscription', rule: 'subscriptions.list' },
      { id: 'grey_plate', name: 'Серый список', path: '/payments/grey_plate' },
    ],
  },
  // reports
  {
    type: 'section',
    id: 'reports',
    rule: 'subsections',
    name: 'Журналы и отчеты',
    path: '/reports',
    subsections: [
      { id: 'rides', name: 'Проезды', path: '/reports/rides', rule: 'passage.list' },
      { id: 'plate_rides', name: 'Проезды по ГРЗ', path: '/reports/plate_rides', rule: 'passage.list' },
      {
        id: 'cashbox_operations',
        name: 'Кассовые операции',
        path: '/reports/cashbox_operations',
        rule: 'payment.list',
      },
      { id: 'calls', name: 'Звонки', path: '/reports/calls' },
      { id: 'events', name: 'Системные события', path: '/reports/events' },
      { id: 'actions', name: 'Действия пользователя', path: '/reports/actions' },
      { id: 'summary', name: 'Сводный', path: '/reports/summary', rule: 'reports.get_xls' },
      { id: 'benefits', name: 'Льготы', path: '/reports/benefits', rule: 'show' },
      { id: 'discounts', name: 'Скидки', path: '/reports/discounts', rule: 'right', ruleTest: 'benefit_check.list' },
      { id: 'promises', name: 'Договор паркирования', path: '/reports/promises', rule: 'right', ruleTest: 'promise_pay.edit' },
      { id: 'additional', name: 'Отчеты', path: '/reports/additional', rule: 'config', ruleTest: (config) => !!config.network.additional_reports_url },
      { id: 'refund', name: 'Сдача', path: '/reports/refund' },
    ],
  },
  {
    type: 'section',
    id: 'options',
    rule: 'subsections',
    name: 'Настройки',
    path: '/options',
    subsections: [
      { id: 'tariffs', name: 'Тарифы', path: '/options/tariffs', rule: 'tariff.list' },
      { id: 'rules', name: 'Правила въезда', path: '/options/rules' },
      { id: 'users', name: 'Пользователи', path: '/options/users' },
      { id: 'collection', name: 'Инкассаторы', path: '/options/collection' },
      { id: 'roles', name: 'Роли', path: '/options/roles' },
      { id: 'categories', name: 'Категории', path: '/options/categories', rule: 'vehicle_category.list' },
      { id: 'benefit_types', name: 'Скидки', path: '/options/benefit_types', rule: 'right', ruleTest: 'benefit_types_check.list' },
      { id: 'parkings', name: 'Закрытие парковок', path: '/options/parkings', rule: 'right', ruleTest: 'stays.auto_close' },
      { id: 'optadv', name: 'Реклама', path: '/options/adv', rule: 'right', ruleTest: 'advertising' },
      { id: 'soupload', name: 'Загрузка СО', path: '/options/soupload', hidden: true, rule: 'show' },
    ],
  },
  { type: 'card', id: 'new_tariff', path: '/card/new_tariff', rule: 'tariff.add' },
  { type: 'card', id: 'tariff', path: '/card/tariff' },
];

const paths = {};
sections.forEach((el) => {
  paths[el.id] = el.path;
  if (el.subsections) {
    el.subsections.forEach((el1) => {
      paths[el1.id] = el1.path;
    });
  }
});

/**
 * find section path
 * @param {*} id
 * @returns
 */
export const path = (id) => {
  if (!paths[id]) {
    throw new Error('findPath: section ' + id + ' not found');
  }
  return paths[id];
};
